<template>
  <div class="rule">
    <van-icon v-if="$route.query.isBanner == 0 && $route.query.isApp == 1" id="backIcon" @click="$router.back()" :name="isDirection ? 'arrow' : 'arrow-left'" />
    <div>
      <b>{{ $t("300140") }}</b>
      <div v-html="rule"></div>
    </div>
  </div>
</template>

<script>
import { signConfigApi } from "../api/resource";
import { Icon} from "vant";

export default {
  components: {
    vanIcon:Icon
  },
  data() {
    return {
      rule: ""
    };
  },
  created() {
    signConfigApi().then(res => {
      this.rule = res.data.rule;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
#backIcon{
  margin: torem(16) torem(0) torem(0);
  font-size: torem(18);
}
.rule {
  line-height: torem(20);
  padding: 0 torem(25) torem(20);
  background: #fff;
  min-height: 100vh;
  //overflow-y: scroll;
  b {
    font-size: torem(16);
    padding: torem(0) 0 torem(20);
    line-height: torem(60);
  }
  font-size: torem(14);
}
</style>



// WEBPACK FOOTER //
// src/view/rules.vue